<section class="fluid-container">
    <div class="container">
        <div
            class="d-flex flex-row justify-content-lg-around justify-content-center flex-wrap flex-lg-nowrap"
        >
            <a
                *ngIf="
                    content.valueExists('footer-facebook-share-link') | async
                "
                href="https://www.facebook.com/sharer.php?display=page&u={{
                    'footer-facebook-share-link' | cmsText | async
                }}"
                type="button"
                class="d-flex align-items-center btn btn-link btn-sm text-decoration-none"
                target="_blank"
            >
                <span
                    class="fab fa-facebook fa-3x"
                    aria-hidden="true"
                    style="color: #1877f2"
                ></span>
                <span class="ml-1">{{
                    'footer-facebook-share-link-text' | cmsText | async
                }}</span>
            </a>
            <a
                *ngIf="content.valueExists('footer-twitter-share-link') | async"
                href="https://twitter.com/intent/tweet?text={{
                    'footer-twitter-share-text' | cmsText | async
                }}&url={{ 'footer-twitter-share-link' | cmsText | async }}"
                type="button"
                class="d-flex align-items-center btn btn-link btn-sm text-decoration-none"
                target="_blank"
            >
                <span
                    class="fab fa-twitter fa-3x"
                    aria-hidden="true"
                    style="color: #00a3f7"
                ></span>
                <span class="ml-1">{{
                    'footer-twitter-share-link-text' | cmsText | async
                }}</span>
            </a>
            <a
                *ngIf="content.valueExists('footer-line-share-link') | async"
                href="https://social-plugins.line.me/lineit/share?url={{
                    'footer-line-share-link' | cmsText | async
                }}"
                type="button"
                class="d-flex align-items-center btn btn-link btn-sm text-decoration-none"
                target="_blank"
            >
                <span
                    class="fab fa-line fa-3x"
                    aria-hidden="true"
                    style="color: #00bd00"
                ></span>
                <span class="ml-1">{{
                    'footer-line-share-link-text' | cmsText | async
                }}</span>
            </a>
        </div>
    </div>
</section>
